const unPow = (value: number, pow: number): number => value / Math.pow(10, pow);
export const calcRewardPow = (reward: number, toFix: number = 6): string =>
    unPow(reward, 18).toFixed(toFix);
export const calcReward = (reward: number, toFix: number = 6): string => reward.toFixed(toFix);

export const calcGasPrice = (price: number): number => Math.round(unPow(price, 9));